export const money = (n, sym = "$") => {
  const v = Number(n) || 0;
  return (
    (v < 0 ? "-" : "") +
    sym +
    Math.abs(v).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
  );
};

export const money0 = (n, sym = "$") =>
  sym + Math.round(Number(n) || 0).toLocaleString("en-US");

/** Dates from Postgres arrive as YYYY-MM-DD (or ISO); render without timezone drift. */
const asDate = (d) => {
  if (!d) return null;
  const s = typeof d === "string" ? d.slice(0, 10) : new Date(d).toISOString().slice(0, 10);
  const [y, m, day] = s.split("-").map(Number);
  return new Date(Date.UTC(y, m - 1, day));
};

export const fmtDate = (d) => {
  const x = asDate(d);
  return x ? x.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric", timeZone: "UTC" }) : "—";
};

export const fmtDateShort = (d) => {
  const x = asDate(d);
  return x ? x.toLocaleDateString("en-US", { month: "short", day: "numeric", timeZone: "UTC" }) : "—";
};

export const isoDate = (d) => (d ? String(d).slice(0, 10) : "");
export const today = () => new Date().toISOString().slice(0, 10);
export const addDays = (iso, n) => new Date(Date.parse(`${isoDate(iso)}T00:00:00Z`) + n * 86400000).toISOString().slice(0, 10);

export const daysUntil = (d) => {
  const x = asDate(d);
  if (!x) return 0;
  const now = asDate(new Date());
  return Math.round((x - now) / 86400000);
};

export const fmtWhen = (ts) => {
  if (!ts) return "";
  const then = new Date(ts);
  const mins = Math.round((Date.now() - then) / 60000);
  if (mins < 1) return "just now";
  if (mins < 60) return `${mins}m ago`;
  if (mins < 60 * 24) return `${Math.round(mins / 60)}h ago`;
  const days = Math.round(mins / (60 * 24));
  if (days === 1) return "yesterday";
  if (days < 30) return `${days} days ago`;
  return fmtDateShort(ts);
};

export const hours = (minutes) => (Number(minutes || 0) / 60).toFixed(2);
export const hoursShort = (minutes) => {
  const m = Math.round(Number(minutes) || 0);
  return `${Math.floor(m / 60)}h ${String(m % 60).padStart(2, "0")}m`;
};
export const clock = (secs) =>
  [Math.floor(secs / 3600), Math.floor(secs / 60) % 60, secs % 60]
    .map((x) => String(x).padStart(2, "0"))
    .join(":");

export const initials = (name = "") =>
  name.trim().split(/\s+/).slice(0, 2).map((w) => w[0] || "").join("").toUpperCase() || "?";

const hueOf = (s = "") => {
  let h = 0;
  for (const c of s) h = (h * 31 + c.charCodeAt(0)) % 360;
  return h;
};
export const avatarColor = (name) => `hsl(${hueOf(name)} 42% 42%)`;

export const pct = (part, whole) => (whole ? Math.round((Number(part) / Number(whole)) * 100) : 0);

export const titleCase = (s = "") => s.charAt(0).toUpperCase() + s.slice(1);
